<template>
    <div class="file-detail-subtab">
        <div class="file-detail-btn" v-if="!readonly">
            <lots-button type="text" icon="el-icon-circle-plus-outline" size="medium" @click="handleAddRow" :disabled="isChangeBasicType?changeIsDisableBtn :isDisableBtn"
             v-has="authorityCode.subAddNewRate">新增</lots-button>
            <lots-button type="text" icon="el-icon-circle-check" size="medium"
                @click="handleSaveRows" :disabled="isChangeBasicType?changeIsDisableBtn :isDisableBtn" :loading="saveLoading" v-has="authorityCode.subSaveRate">保存</lots-button>
            <lots-button type="text" icon="el-icon-delete" size="medium" @click="handleDeleteRows" :disabled="isChangeBasicType?changeIsDisableBtn :isDisableBtn"
                v-has="authorityCode.subDeleteRate">删除</lots-button>
            <lots-button type="text" icon="el-icon-circle-plus-outline"
                size="medium"
                v-has="authorityCode.rateAddPrivilege"
                v-if="isShowPrivilegeBtn"
                :disabled="detailPageState === 'new' || !detailData.contractCode"
                @click="handleAddRow">特权新增</lots-button>
            <lots-button type="text" icon="el-icon-circle-check" size="medium"
                v-has="authorityCode.rateSavePrivilege"
                                v-if="isShowPrivilegeBtn"
                :disabled="detailPageState === 'new' || !detailData.contractCode"
                @click="handleSaveRows"
                :loading="saveLoading">特权保存</lots-button>
            <lots-button type="text" icon="el-icon-delete" size="medium"
                v-has="authorityCode.rateDeletePrivilege"
                                v-if="isShowPrivilegeBtn"
                :disabled="detailPageState === 'new' || !detailData.contractCode"
                @click="handleDeleteRows">特权删除</lots-button>
        </div>
        <div class="file-detail-table">
                <edit-table-box
                    class="prescreen"
                    :control="true"
                    v-loading="subTabTable.tableLoading"
                    ref="editTableBox"
                    :selection="newConfig.selection"
                    :columns="newConfig.columns"
                    :height="tableHeight"
                    :tableData="subTabTable.totalData"
                    :actions="newConfig.actions"
                    @selection-change="handleSelectedRow"
                    @element-change="handleChangeRow"
                >
                <template v-slot:col-append="{item, row, rIndex}">
                    <div v-if="item.prop ==='businessType'">
                        {{dictData.SYS_BMS_BUSI_TYPE?dictData.SYS_BMS_BUSI_TYPE[row[item.prop]]:''}}
                    </div>
                    <div v-else-if="item.prop ==='rateImpExp'">
                        {{dictData.RATE_IMP_EXP?dictData.RATE_IMP_EXP[row[item.prop]]:''}}
                    </div>
                </template>
                </edit-table-box>
            <div class="footer">
                <lots-pagination
                    @size-change='subTabTable.sizeChange'
                    :current-page.sync='subTabTable.pageNo'
                    @current-change='subTabTable.pageChange'
                    size="small" layout='total, sizes, prev, pager, next, jumper'
                    :total='subTabTable.pageTotal'/>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, watch, onActivated, computed, onMounted } from '@vue/composition-api';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { STATE_NEW, STATE_OTHER_CHANGE } from '@/modules/mdm/constant/contractManage.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { tableConfig } from './config.js';
import { Message } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import {
    rateInfoList,
    rateInfoDelete,
    rateInfoSave,
    getChangeContractRatePage,
    saveChangeContractRate, deleteChangeContractRate
} from '@mdm/api/contractManage/contractFootPageApi.js';
import _ from 'lodash';
import { dictWithUrl } from '@/components/lots/api';
export default {
    name: '',
    components: { lotsPagination, editTableBox, lotsButton }, // tableBox, lotsSelect, otpAdvance, DialogImportFile, lotsButton,
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailPageState: {
            type: String,
            default() {
                return '';
            }
        },
        detailData: {
            type: Object,
            return: () => {}
        },
        tableHeight: {
            type: Number,
            default: 325
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        // const config = reactive(tableConfig);
        const authorityCode = reactive(btnAuthority.contractManage);
        const isDisableBtn = ref(false);
        const changeIsDisableBtn = ref(false);
        const saveLoading = ref(false);
        const newConfig = computed(() => {
            const _config = _.cloneDeep(tableConfig);
            _config.columns.forEach(it => {
                if (it.prop === 'businessType') {
                    it.options = getNewOptions(props.detailData, dictData.value?.SYS_BMS_BUSI_TYPE);
                }
                if (it.prop === 'rateImpExp') {
                    it.options = dictData.value?.RATE_IMP_EXP || {};
                    it.mustFill = props.detailData.contractAttribute?.toString() === '2';
                }
            });
            if (props.detailData.contractGroupCode || props.detailData.contractAttribute?.toString() !== '2') {
                _config.columns = _config.columns.filter(it => it.prop !== 'rateImpExp');
            }
            return _config;
        });
        const isChangeBasicType = computed(() => {
            const changeRate = (props.detailPageState === STATE_OTHER_CHANGE && props.detailData.changeType?.toString() === '0');
            return changeRate ? !(props.detailData.contractChangeStatus + '' === '0' || props.detailData.contractChangeStatus + '' === '1') : false;
        });
        const getNewOptions = (data, options) => {
            if (!options) return [];
            const businessTypes = data.businessType || [];
            return _.pick(options, businessTypes);
        };

        class DataDetailClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.contractCode = props.detailData.contractCode;
                if (props.detailPageState === STATE_OTHER_CHANGE && props.detailData.changeType?.toString() === '0') {
                    condition.contractCode = props.detailData.contractCode;
                    condition.contractChangeCode = props.detailData.contractChangeCode;
                }
                return condition;
            };
            afterGetList (res) {
                if (+res.code === 0 && res.data) {
                    this.totalData.value = res.data.list?.map(it => {
                        it.businessType = it.businessType?.toString();
                        it.rateImpExp = it.rateImpExp?.toString();
                        return it;
                    }) || [];
                    this.pageNo.value = res.data.pageNo;
                    this.pageSize.value = res.data.pageSize;
                    this.pageTotal.value = res.data.totalCount;
                }
            };
        };
        const subTabTable = new DataDetailClass({
            Api: {
                listApi: rateInfoList,
                deleteApi: rateInfoDelete
            }
        });
        const isShowPrivilegeBtn = computed(() => {
            return props.detailPageState !== STATE_OTHER_CHANGE;
        });
        const btnLoading = ref(false);
        const handleAddRow = () => {
            setupContext.refs.editTableBox.addRow();
            subTabTable.totalData.value[0].disableProps = ['costTypeName']; // 新增时业务类型为空，禁用费用名称
        };
        const selectedRows = ref([]); // 选中的行数组
        const handleSelectedRow = (selection) => {
            selectedRows.value = selection;
        };
        const handleChangeRow = ({ prop, val, type, row, index }) => {
            if (prop === 'businessType') { // 操作业务类型,置空其他值
                row['costTypeCode'] = null;
                row['costTypeName'] = null;
                row['taxRateCode'] = null;
                row['rate'] = null;
                row.disableProps = val ? [] : ['costTypeName']; // 为空，禁用费用名称
            }
            if (type === 'advance' && val['costTypeName'] !== undefined) { // 费用弹框清空
                row['taxRateCode'] = null;
                row['rate'] = null;
            }
        };
        const handleSaveRows = async () => {
            if (!subTabTable.totalData.value.length) {
                return Message.warning('目前无数据无法保存！');
            }
            try {
                subTabTable.totalData.value.forEach(v => {
                    if (setupContext.refs.editTableBox.saveItemData(v) === false) {
                        throw Error();
                    }
                });
            } catch (err) { return; }
            const changeRate = (props.detailPageState === STATE_OTHER_CHANGE && props.detailData.changeType?.toString() === '0');
            subTabTable.totalData.value.forEach(e => {
                e.costTypeName = e.costTypeName || null;
                e.costTypeCode = e.costTypeCode || null;
                e.contractCode = props.detailData.contractCode === '0000' ? null : props.detailData.contractCode;
                if (changeRate) {
                    e.contractCode = props.detailData.contractChangeCode;
                }
            });
            saveLoading.value = true;
            let Api = rateInfoSave;
            let params = subTabTable.totalData.value;
            if (changeRate) {
                Api = saveChangeContractRate;
                params = subTabTable.totalData.value.map(it => {
                    it.contractChangeCode = props.detailData.contractChangeCode;
                    it.contractCode = props.detailData.contractCode;
                    return it;
                });
            }
            const res = await Api(params);
            saveLoading.value = false;
            if (res && +res.code === 0) {
                Message({
                    message: '成功保存' + res.data + '条数据',
                    type: 'success'
                });
                subTabTable.getList(); // 刷新列表
            }
        };
        const handleDeleteRows = async () => { // 调批量删除接口
            if (selectedRows.value.length === 0) {
                Message.error('请选择需要删除的条目');
                return;
            }
            let passFlag = true;
            selectedRows.value.forEach(item => {
                if (!item.id) {
                    passFlag = false;
                }
            });
            if (!passFlag) {
                return Message.warning('存在新增未保存的数据，请先保存或取消编辑');
            }
            const ids = JSON.parse(JSON.stringify(selectedRows.value)).map((v) => v.id);
            subTabTable.deleteRow({ ids }, false);
        };
        watch(
            () => [props.detailPageState, props.detailData.contractStatus, props.activeName, props.detailData.contractCode],
            (newVal) => {
                if (newVal[2] === 'rateDetail') { // props.activeName
                    const changeRate = (newVal[0] === STATE_OTHER_CHANGE && props.detailData.changeType?.toString() === '0');
                    changeIsDisableBtn.value = changeRate;
                    if (newVal[0] === STATE_NEW || changeRate) {
                        isDisableBtn.value = false;
                    } else {
                        isDisableBtn.value = !(newVal[1] + '' === '0' || newVal[1] + '' === '1');
                    }
                    if (newVal[3]) { // contractCode
                        if (changeRate) {
                            subTabTable.updateListApi(getChangeContractRatePage);
                            subTabTable.updateDeleteApi(deleteChangeContractRate);
                        }
                        subTabTable.getList();
                    } else {
                        subTabTable.totalData.value = [];
                        subTabTable.pageTotal.value = 0;
                    }
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        const dictData = ref({});
        onMounted(async() => {
            const res = await dictWithUrl('SYS_BMS_BUSI_TYPE,RATE_IMP_EXP');
            if (res && +res.code === 0) {
                dictData.value = res.data;
            }
        });
        onActivated(() => {
            setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
        });
        return {
            isDisableBtn,
            changeIsDisableBtn,
            isChangeBasicType,
            newConfig,
            subTabTable,
            btnLoading,
            handleAddRow,
            handleSelectedRow,
            handleChangeRow,
            handleSaveRows,
            handleDeleteRows,
            authorityCode,
            saveLoading,
            isShowPrivilegeBtn,
            dictData
        };
    }
};
</script>
